module.exports = __webpack_public_path__ + "img/null.547bec8d.svg";